import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// components
import { Period, Summary, DeleteModal } from '../../components'
import { Empty } from '../reviewList/components'

import { Table, Search } from './components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'
import { getExcelFile } from '../../utils/getExcelFile'
import { getComma } from '../../utils/getComma'
import { getMonthPeriod } from '../../utils/getMonthPeriod'
import { getExcelDownload } from '../../utils/getExcelDownload'

// temp
const DETAIL_STATS = [
  { main: '64', sub: '성공 주문' },
  { main: '3', sub: '취소 주문' },
  { main: '95.5%', sub: '주문 처리율' },
]

const CALCULATION_TYPE = {
  PRICE: 'calculationSumPrice',
  COUNT: 'calculationCount',
  LIST: 'calculationList',
  PERIOD: 'calculationPeriod',
}

export default function Settlements() {
  const { fetchData, loading, data, error } = useAxios()

  // 디폴트 1년
  // ex)현재 11월 - 작년 10월 ~ 올해 10월
  // + 주차
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  // 드롭다운
  const [settlementMonth, setSettlementMonth] = useState(
    !startDate || !endDate
      ? []
      : getMonthPeriod(startDate.slice(0, -1), endDate.slice(0, -1)),
  )
  const [isInit, setIsInit] = useState(false)

  // 정산 아이템
  const [settlementItem, setSettlementItem] = useState({
    total: 0,
    list: null,
    price: 0,
  })

  // 페이지네이션
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)

  // 빈값
  const [isEmpty, setIsEmpty] = useState(false)

  // 요청 체크
  const [isFetch, setIsFetch] = useState(false)

  // 모달
  const [excelItem, setExcelItem] = useState(null)
  const [isVisibleModal, setIsVisibleModal] = useState(false)

  useEffect(() => {
    getSettlementList(page, size)
  }, [])

  useEffect(() => {
    if (isFetch) {
      getSettlementList(page, size)
    }
  }, [startDate, endDate, isFetch, page, size])

  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData

    switch (resCode) {
      // 성공(데이터 O)
      case TYPE.API_RESPONSE.SUCCESS:
        // 엑셀
        if (resData.hasOwnProperty('calculationExcel')) {
          getExcelDownload(resData.calculationExcel, resData.fileName)
        }
        // 조회
        else {
          setIsFetch(false)

          // 개수, 목록, 금액
          setSettlementItem({
            total: resData.calculationCount,
            list: resData.calculationList,
            price: getComma(resData.calculationSumPrice),
          })

          // 주기는 한 번만 조회
          if (
            resData.hasOwnProperty(CALCULATION_TYPE.PERIOD) &&
            resData.calculationPeriod.length > 0
          ) {
            let calculationPeriod = resData.calculationPeriod.map(
              (item) =>
                `${item.summaryYear}년 ${item.summaryMonth}월 ${item.summaryChasu}차`,
            )

            const firstIndex = resData.calculationPeriod[0]
            const lastIndex =
              resData.calculationPeriod[resData.calculationPeriod.length - 1]

            setStartDate(
              `${lastIndex.summaryYear}${lastIndex.summaryMonth}${lastIndex.summaryChasu}`,
            )
            setEndDate(
              `${firstIndex.summaryYear}${firstIndex.summaryMonth}${firstIndex.summaryChasu}`,
            )
            setSettlementMonth(calculationPeriod)
          }
        }

        break

      // 성공(데이터 X)
      case TYPE.API_RESPONSE.NOT_DATA:
        setIsEmpty(true)
        setSettlementItem({
          total: 0,
          list: null,
          price: 0,
        })
        break

      // 실패
      case TYPE.API_RESPONSE.FAILURE:
      default:
        break
    }
  }, [data])

  // 정산 조회(주기, 요약, 목록)
  const getSettlementList = (pageNum, tableSize) => {
    const params = {
      ...(startDate && { startYearMonth: startDate }),
      ...(endDate && { endYearMonth: endDate }),
      page: pageNum,
      size: tableSize,
    }

    fetchData(
      constants.API.SETTLEMENT_LIST,
      'GET', // method
      null, // body
      params, // params
    )
  }

  const handleTableSize = (num) => {
    setIsFetch(true)
    setSize(num)
    setPage(1)
  }

  const handleExcel = (item) => {
    if (!item) return

    // 모달 다운로드 관련 코드
    // if (!excelItem) return

    // 모달 다운로드 관련 코드
    // const { summaryYear, summaryMonth, summaryChasu } = excelItem
    const { summaryYear, summaryMonth, summaryChasu } = item

    const params = {
      detailYear: summaryYear,
      detailMonth: summaryMonth,
      detailChasu: summaryChasu,
    }

    // alert('엑셀 파일 다운로드를 시작합니다.')

    // 상세 다운로드(기존)
    // getExcelFile(
    //   constants.API.SETTLEMENT_EXCEL_DETAIL,
    //   null,
    //   params,
    //   `정산명세서_상세_${summaryYear}_${summaryMonth}_${summaryChasu}`,
    // )

    // 변경
    fetchData(
      constants.API.SETTLEMENT_EXCEL_DETAIL,
      'GET', // method
      null, // body
      params, // params
    )

    // downloadFile(constants.API.SETTLEMENT_EXCEL_DETAIL, null, params)

    // setExcelItem(null)
  }

  const handleDropdown = (opt, flag) => {
    if (settlementMonth.length === 0) return

    const chasuStr = opt.split('월')[1].replace(/[^0-9]/g, '')
    const formatStr = opt.split('월')[0].replace(/[^0-9]/g, '')

    switch (flag) {
      // 시작일
      case 0:
        setStartDate(`${formatStr}${chasuStr}`)
        break

      // 마감일
      case 1:
        setEndDate(`${formatStr}${chasuStr}`)
        break

      default:
        break
    }

    setIsInit(true)
    setIsFetch(true)
    setPage(1)
  }

  // 엑셀 다운로드 모달 on
  // 통계와 다르게 각각 주차별로 정산을 다운 받기 떄문에
  // 모달 제거됨
  const openModal = (item) => {
    setExcelItem(item)
    setIsVisibleModal(true)
  }

  // 엑셀 다운로드 모달 off
  const closeModal = () => {
    setExcelItem(null)
    setIsVisibleModal(false)
  }

  // 공통 유틸로 분리
  const excelDownload = (base64Data, fileName) => {
    // Base64 디코딩
    const byteCharacters = atob(base64Data)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)

    // blob 생성
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    // a 태그를 사용하여 다운로드 링크 생성
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <>
      <Container>
        <Period
          dateText={'날짜 직접 선택'}
          isSettlement={true}
          isVisible={false}
        >
          <Search
            isEmpty={isEmpty}
            settlementMonth={settlementMonth}
            startDate={startDate}
            endDate={endDate}
            isInit={isInit}
            handleDropdown={handleDropdown}
          />
        </Period>
        <Summary
          singleStat={true}
          titleLabel={'총입금금액(예정포함)'}
          titleStat={`${settlementItem.price}원`}
          detailStats={DETAIL_STATS}
        />

        <Wrapper>
          <>
            {isEmpty ? (
              <Empty pointTxt={'정산내역'} txt={'이 없습니다.'} />
            ) : (
              <Table
                size={size}
                page={page}
                settlementItem={settlementItem}
                setSize={handleTableSize}
                setPage={(num) => setPage(num)}
                // handleExcel={(item) => openModal(item)}
                handleExcel={handleExcel}
              />
            )}
          </>
        </Wrapper>
      </Container>

      <DeleteModal
        show={isVisibleModal}
        message={'엑셀 파일을 다운로드 하시겠습니까?'}
        buttons={['취소', '확인']}
        handleClose={() => {
          closeModal()
        }}
        handleSubmit={() => {
          handleExcel()
          closeModal()
        }}
      />
    </>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
const Wrapper = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  display: flex;
  flex-direction: row;

  @media ${(props) => props.theme.mobile} {
    /* overflow-x: auto; */
  }
`
